export const DomDeltaLine = WheelEvent.DOM_DELTA_LINE

export const DomDeltaPixel = WheelEvent.DOM_DELTA_PIXEL

export const DomDeltaPage = WheelEvent.DOM_DELTA_PAGE
